import { Tracking } from './Tracking';

export enum HelperTrackStages {
    SHOW = 'Show',
    CONFIRM = 'Confirm',
    ENTRY = 'Entry',
}

export default class HelperTracking {
    public static track(item: string, stage: HelperTrackStages) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Helper${item}${stage}`,
        });
    }
}
